// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"120":"4b32762b6ca315dc","888":"e2f1d082e7966b0a"}[chunkId] + ".css";
};